import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const SDKInfoGet = new ReduxAsyncAction('SDK_INFO_GET');
SDKInfoGet.registerRequest(function () {
  return dash_api.post('/v1/sdk/get-status', {}).then(({ data }) => data);
});

export const loadSDKInfo = SDKInfoGet.request;
export const SDK_INFO_GET = SDKInfoGet.constants;

const SDKLatestInfo = new ReduxAsyncAction('SDK_LATEST_INFO');
SDKLatestInfo.registerRequest(function () {
  return dash_api.get('/v1/sdk/latest-versions').then(({ data }) => data);
});
export const loadSDKLatestInfo = SDKLatestInfo.request;
export const SDK_LATEST_INFO = SDKLatestInfo.constants;
